module.exports = __webpack_public_path__ + "img/Photo_2__Second_Canal_988_11_3.f95c0fbf.jpg";